/**
 * Helper class that works on the observer principle to notify a user token
 * has expired. Used in the context to provide an expiration callback to React
 *
 * @class UserExpiration
 */
export class UserExpiration {
    /**
     * The array of callbacks that are subscribed to user token expirations
     *
     * @private
     */
    callbacks = [];
    /**
     * Remember the last emitted token to prevent rapid firing the same token.
     * Quite common when a cluster of services was queued.
     *
     * @private
     * @type {string}
     */
    lastToken = '';
    /**
     * Add a callback to receive expired tokens
     *
     * @param {TUserTokenExpiredCallback} callback
     */
    subscribe(callback) {
        // Unsubscribe first to prevent double registrations of the same callback
        //
        this.unsubscribe(callback);
        this.callbacks.push(callback);
    }
    /**
     * Remove a callback to stop receiving expired user tokens
     *
     * @param {TUserTokenExpiredCallback} callback
     */
    unsubscribe(callback) {
        this.callbacks = this.callbacks.filter((existingCallback) => {
            if (callback !== existingCallback) {
                return existingCallback;
            }
        });
    }
    /**
     * Notify a user token has expired
     *
     * @param {string} userToken
     * @returns
     */
    tokenExpired(userToken) {
        if (!userToken || userToken === this.lastToken) {
            return;
        }
        for (const callback of this.callbacks) {
            callback(userToken);
        }
        this.lastToken = userToken;
    }
}
const userExpiration = new UserExpiration();
export default userExpiration;
//# sourceMappingURL=user-expiration.js.map